var map = {
	"./amaze.png": 91001,
	"./angel.png": 54751,
	"./angry.png": 87438,
	"./applause.png": 95133,
	"./arrogant.png": 69275,
	"./astonished.png": 59305,
	"./awkward.png": 47629,
	"./bigcry.png": 50438,
	"./blessing.png": 73791,
	"./boo.png": 68596,
	"./bye.png": 58393,
	"./candle.png": 47318,
	"./cheer.png": 46449,
	"./comic.png": 16957,
	"./cool.png": 25428,
	"./crazy.png": 53093,
	"./cry.png": 45681,
	"./cute.png": 90834,
	"./daze.png": 13247,
	"./dignose.png": 80032,
	"./dizzy.png": 40058,
	"./dog.png": 30221,
	"./dontbicker.png": 86187,
	"./doubt.png": 74457,
	"./drinktea.png": 12080,
	"./dung.png": 22529,
	"./embrace.png": 39527,
	"./evil.png": 85742,
	"./facepalmcry.png": 66817,
	"./fallill.png": 78245,
	"./follow.png": 33816,
	"./frown.png": 86070,
	"./handshake.png": 70586,
	"./hard.png": 25589,
	"./heart.png": 74479,
	"./hehe.png": 42355,
	"./kiss.png": 41925,
	"./kneel.png": 76850,
	"./kneelcry.png": 52691,
	"./laughcry.png": 77281,
	"./lechery.png": 48082,
	"./letgo.png": 34034,
	"./like.png": 7235,
	"./majestic.png": 57238,
	"./ok.png": 12895,
	"./pathetic.png": 80257,
	"./praise.png": 85841,
	"./reversesmile.png": 22634,
	"./rose.png": 12697,
	"./shutup.png": 75002,
	"./shy.png": 48065,
	"./simper.png": 69473,
	"./slap.png": 20232,
	"./sleep.png": 57864,
	"./sleepy.png": 84059,
	"./smile.png": 62931,
	"./snap.png": 71866,
	"./split.png": 78727,
	"./stoptalking.png": 86504,
	"./struggle.png": 27019,
	"./sweat.png": 19751,
	"./teethlaugh.png": 45322,
	"./titter.png": 91709,
	"./vomit.png": 50758,
	"./wane.png": 97437,
	"./watermelon.png": 73217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96504;